import React from "react"
import PropTypes from 'prop-types'
import {
    InstantSearch,
    Configure,
} from 'react-instantsearch-dom'

const algoliasearch = require(`algoliasearch`)
const searchClient = algoliasearch(`I8MGL0UDWW`, process.env.ALGOLIA_ADMIN_KEY)

const SearchWrapper = ({ children }) => (
    <InstantSearch
        appId="I8MGL0UDWW"
        apiKey="e546f70155732c267bdc8dce8dd4f077"
        indexName="concept"
        searchClient={searchClient}
    >
        <Configure attributesToSnippet="html" />
        {children}
    </InstantSearch>
)

SearchWrapper.propTypes = {
    children: PropTypes.node.isRequired,
}

export default SearchWrapper
